module.exports = __webpack_public_path__ + "static/media/markup.7bcb09de.svg";